module.exports = "/_next/static/images/hack-1ffe27a029e829572e2638af48e5712e.png";